import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    AddressFormatter,
    CurrencyFormatter,
    OptionFormatter,
    remoteComponentFormatter,
    remoteOptionFormatter
} from "../../../utils/formatters";
import {componentFilter, optionFilter} from "../../../utils/filters";

class paymentList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, pageSize} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: pageSize || 0, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "paymentList"}
                {...props}
                aggregations={{
                    fields: {
                        "amount": {
                            field: "amount", type: "SUM"
                        }
                    }
                }}
                columns={{
                    [componentConfig.idfield]: {header: 'Tranz. sz.', width: 1, sortable, filterable},
                    "amount": {
                        header: 'Fizetendő',
                        width: 1,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter,
                        className: "currency"
                    },
                    "serviceprovider_type": {
                        header: 'Fizetés módja',
                        width: 1,
                        sortable,
                        filterable: componentFilter({component: "PaymentServiceProvider", labelfield: "methodname"}),
                        renderer: (value) => <div className="nowrap">{remoteComponentFormatter({component: "PaymentServiceProvider", labelfield: "methodname"})(value)}</div>
                    },
                    "status": {
                        header: 'Státusz',
                        width: 1,
                        sortable,
                        //filterable: optionFilter("KhStatus"),
                        renderer: (value, row) => remoteOptionFormatter(row.serviceprovider_type + "Status")(value)
                    },
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default paymentList;
